var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 41,
    viewBox: "0 0 72 41",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.47505 24.1122C3.15027 17.865 8.52672 13.0145 14.0582 12.7273C21.4097 12.3453 25.9084 18.2353 26.22 23.096C26.7072 30.7938 20.7601 35.2944 15.2652 35.4883C8.36725 35.7347 3.15027 30.0372 3.47505 24.1122ZM6.54731 24.2317C6.53767 25.3302 6.74826 26.4195 7.16671 27.4358C7.58516 28.4521 8.20306 29.3748 8.98415 30.15C9.76524 30.9251 10.6938 31.537 11.7153 31.9497C12.7369 32.3625 13.8309 32.5677 14.9331 32.5535C19.7478 32.4923 23.2589 28.6507 23.2077 24.0261C23.1594 19.5445 19.3074 15.802 14.8087 15.8618C10.2194 15.9201 6.48732 19.6976 6.53999 24.2317H6.54731Z",
    fill: "url(#paint0_linear_313_13019)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0167 24.1896C67.4264 29.4862 62.3762 35.8165 54.9047 35.4681C49.2459 35.2042 44.1533 30.0315 44.1679 24.0875C44.184 17.8185 49.3849 12.6559 55.6523 12.7157C62.2928 12.7697 67.3591 18.2762 67.0167 24.1896ZM47.3514 24.3047C47.3938 28.8039 50.9108 32.5814 55.7167 32.5653C60.5445 32.5493 64.0996 28.7747 64.0425 24.054C64.004 21.866 63.1011 19.7814 61.5297 18.2528C59.9583 16.7243 57.8453 15.8751 55.6494 15.8896C51.0118 15.9465 47.2826 19.7269 47.3514 24.3047Z",
    fill: "url(#paint1_linear_313_13019)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4349 40.8375C21.4508 41.4484 24.6182 40.1902 26.9033 36.8224C27.2852 36.2597 27.5982 35.6561 27.9654 35.0817C30.274 31.501 34.4728 29.941 38.3819 31.2196C40.9567 32.0623 42.7313 33.8293 43.969 36.1693C45.685 39.4161 49.2825 41.654 53.9362 40.8273C57.0495 40.2762 60.211 40.0007 63.3505 39.5954C64.6292 39.4307 65.9444 39.3869 67.1733 39.0414C69.9281 38.2672 71.255 36.3632 71.255 33.4809C71.255 24.8578 71.255 16.2337 71.255 7.60859C71.2489 6.9059 71.1863 6.20482 71.0677 5.5121C70.7576 3.63867 68.727 1.75795 66.8426 1.60633C62.9336 1.29288 59.0259 0.925479 55.111 0.731576C48.6856 0.415207 42.2587 0.0390629 36.815 0.00261481C30.9441 -0.0280016 26.0694 0.215471 21.2036 0.458944C15.7466 0.733034 10.3088 1.22144 4.86209 1.53052C2.54034 1.66173 -0.0842422 3.85299 0.00207356 6.92483C0.0840004 9.84067 0.0210923 12.7565 0.0210923 15.6724C0.0210923 21.6498 0.0210923 27.6273 0.0210923 33.6048C0.0210923 36.4609 1.39629 38.3605 4.11743 39.0691M15.2653 35.4957C8.36738 35.7348 3.1504 30.0373 3.47518 24.1123C3.1504 17.8651 8.52685 13.0146 14.0584 12.7274C21.4098 12.3454 25.9085 18.2354 26.2201 23.0961C26.7044 30.7939 20.7603 35.2974 15.2653 35.4884V35.4957ZM54.912 35.4753C49.2532 35.2114 44.1606 30.0387 44.1753 24.0948C44.1913 17.8257 49.3922 12.6632 55.6596 12.723C62.3001 12.7813 67.3635 18.2879 67.024 24.2012C67.4264 29.4862 62.3762 35.8165 54.9047 35.468L54.912 35.4753Z",
    fill: "url(#paint2_linear_313_13019)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8015 15.8604C10.2194 15.9202 6.48736 19.702 6.54003 24.2318C6.53039 25.3303 6.74098 26.4196 7.15943 27.4359C7.57788 28.4521 8.19578 29.3749 8.97687 30.1501C9.75796 30.9252 10.6865 31.5371 11.7081 31.9498C12.7296 32.3625 13.8236 32.5678 14.9258 32.5536C19.7405 32.4924 23.2516 28.6508 23.2004 24.0262C23.1522 19.5519 19.3001 15.8021 14.8015 15.8604Z",
    fill: "url(#paint3_linear_313_13019)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6492 15.8911C51.0116 15.9465 47.2825 19.7268 47.3512 24.3047C47.3937 28.8039 50.9107 32.5813 55.7165 32.5653C60.5444 32.5493 64.0994 28.7747 64.0424 24.054C64.0035 21.8662 63.1004 19.782 61.529 18.2538C59.9577 16.7255 57.8449 15.8765 55.6492 15.8911Z",
    fill: "url(#paint4_linear_313_13019)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_313_13019",
    x1: 6.7097,
    y1: 16.0455,
    x2: 22.8503,
    y2: 32.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DE1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2590DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_313_13019",
    x1: 48.4559,
    y1: 16.8825,
    x2: 63.4462,
    y2: 31.9247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DE1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2590DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_313_13019",
    x1: 35.6285,
    y1: 5.36339,
    x2: 35.6285,
    y2: 27.1739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0940CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#093997"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_313_13019",
    x1: 14.8702,
    y1: 5.36338,
    x2: 14.8702,
    y2: 27.1739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0940CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#093997"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_313_13019",
    x1: 55.6961,
    y1: 5.3634,
    x2: 55.6961,
    y2: 27.1739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0940CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#093997"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo.ec232aab.svg";
export { ForwardRef as ReactComponent };